import { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { authFetch } from '../utils/authToken';

const API = `${window.location.origin}/api`;

export const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  // Use THREE states: null = checking, true = authenticated, false = not authenticated
  const [isAuthenticated, setIsAuthenticated] = useState(
    location.state?.user ? true : null
  );
  const [user, setUser] = useState(location.state?.user || null);

  useEffect(() => {
    // Skip auth check if user data was passed from AuthCallback
    if (location.state?.user) {
      return;
    }

    const checkAuth = async () => {
      try {
        const response = await authFetch(`${API}/auth/me`);

        if (!response.ok) {
          throw new Error('Not authenticated');
        }

        const userData = await response.json();
        setUser(userData);
        setIsAuthenticated(true);
      } catch (error) {
        setIsAuthenticated(false);
      }
    };

    checkAuth();
  }, [location.state]);

  // Show loading while checking authentication
  if (isAuthenticated === null) {
    return (
      <div className="min-h-screen bg-[#050505] flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-white border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  // Redirect to auth page if not authenticated
  if (isAuthenticated === false) {
    return <Navigate to="/auth" replace />;
  }

  // Render children if authenticated
  return children;
};

export default ProtectedRoute;
